import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { paths } from '@fleet/environment';
import { handleApiError } from '@fleet/utilities';
import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BraintreeApiService {
  host;
  constructor(private http: HttpClient, @Inject('env') env: any) {
    this.host = env.host + paths.braintree;
  }

  getClientToken(): Observable<any> {
    return this.http
      .get(`${this.host}/clientToken`)
      .pipe(catchError(handleApiError));
  }
}
